export default {
    methods: {
        enforceDecimal(event) {
            const { value } = event.target

            if (event.keyCode === 190) {
                if (value === '.') {
                    event.target.value = ''
                } else if (value.match(/\./g).length > 1) {
                    event.target.value = value.replace(/\.([^.]*)$/, '$1')
                }

                return
            }

            event.target.value = event.target.value.replace(/[^0-9.]/g, '')
        },
    },
}
